module.exports = __webpack_public_path__ + "img/SEND.e79defbe.svg";